import AgentsList from '@/components/AgentsPortal'
import { ChatPortalLayout } from '@sui/chat-ui'
import React from 'react'

export default function indx() {
  return (
    <ChatPortalLayout title='智能体广场'>
      <AgentsList />
    </ChatPortalLayout>
  )
}
